import { ICreatePunchRequestDTO, ICreatePunchResponseDTO, IPunchDTO } from 'src/api/dtos/punch.dto';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';

export default class PunchRepository extends ESSRepository {
  private static readonly baseRoute = '/punches';
  private static readonly apiURL = PunchRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public create = async (payload: ICreatePunchRequestDTO): Promise<ICreatePunchResponseDTO> => {
    try {
      const { data } = await http.post(PunchRepository.apiURL, payload);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getRecentPunches = async (): Promise<IPunchDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IPunchDTO>>(`${PunchRepository.apiURL}/recentpunches`);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
